import React, { useRef, useState, useEffect } from 'react';
import { RadioButtonGroup, RadioButton } from '@vds/inputs';
import { Button } from '@vds/buttons';
import {Input} from '@vds/inputs';
import { Body } from '@vds/typography';

import '../ExistingCustomer/ExistingCustomer.css';
import { scrollRefInView } from '../../../utils/common';
import styled from 'styled-components';
import * as SiteAnalytics from '../../../sitecatalyst';
import { useHistory } from "react-router-dom";

const MarginSpacerM = styled.div`margin-bottom: 1.5rem !important;`;

const ExistingCustomer = ({ newService, previousHasExistingService, showPendingOrderPage, optixAddressQualificationDetails, addressQualificationDetails, priceQuoteNumber, 
    savePriceQuoteNumber, priceQuote, saveOptixMonNumber, postUIEventLog, isExistingServicePage}) => {
    const scrollRef = useRef();
    const [viewPriceQuoteInput, showPriceQuoteInput] = useState(true);
    const [enableErrorMessageForPriceQuoteNumber, setEnableErrorMessageForPriceQuoteNumber] = useState(false);
    const [errorMessageForPriceQuoteNumber, setErrorMessageForPriceQuoteNumber] = useState(false);
    const [radioValue, setRadioValue] = useState(optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField?.length > 0 ? 'existing quote' : 'Y');
    let history = useHistory();
    useEffect(() => {
        scrollRefInView(scrollRef);
        setHasPriceQuote();
        SiteAnalytics.trackPageInfo('ExistingService');
    },[]);
    const setHasPriceQuote = () => {
        hasPriceQuoteNumber()?priceQuote("Y") :priceQuote("N")
    }

    const hasPriceQuoteNumber = () => {
        if(optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField?.length > 0) {
           return true;
        }
        return false;
    }
    
    const getServiceOptions = () => {
        let serviceOptions = []
        if (hasPriceQuoteNumber()) {
            serviceOptions.push({
                name: 'loopqual',
                children: 'Review/access existing quote',
                value: 'existing quote',
            })
        }
        serviceOptions.push({
            name: 'loopqual',
            children: 'Set up new service.',
            value: 'Y',
        })
        if (addressQualificationDetails?.HasExistingService || previousHasExistingService !== 'N') {
            serviceOptions.push({
                name: 'loopqual',
                children: 'Add or change existing service. The existing service is mine.',
                value: 'N',
            })
        }
        return serviceOptions

    }
    const onServiceChange = (event) => {
        setRadioValue(event.target.value);
        if (event.target.value === "existing quote") {
            priceQuote("Y")
            showPriceQuoteInput(true)
        } else {
            priceQuote("N")
            newService(event)
            showPriceQuoteInput(false)
         }
         postUIEventLog({eventType: 'log', eventName: "Existing Customer Radio Click", sectionName: "LQ", log:event.target.value});
    }

    const validatePriceQuoteNumber = (priceQuoteNumber) => {
        let priceQuotesSet = optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField
        for (let i = 0; i < priceQuotesSet?.length; i++) {
            if(priceQuotesSet[i].quoteNumberField === priceQuoteNumber) {
                return true;
            }

        }

        return false;
    };

    const savePriceQuote = (e) => {
        const value = e.target.value;
        const priceQuotes = optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField;
        const monNumber = priceQuotes?.find(q => value === q.quoteNumberField )?.monField;
        savePriceQuoteNumber(value)
        saveOptixMonNumber(monNumber);
        setEnableErrorMessageForPriceQuoteNumber(false)       
    }

    const onContinue = (e) => {
        history.push({ pathname: "/ExistingService", state: { prevPage: 'ExS' } });
        if ((viewPriceQuoteInput && hasPriceQuoteNumber()) && !validatePriceQuoteNumber(priceQuoteNumber)) {
            setEnableErrorMessageForPriceQuoteNumber(true)
            setErrorMessageForPriceQuoteNumber("Please enter valid price quote number")
        } else {
            showPendingOrderPage(e,(viewPriceQuoteInput && hasPriceQuoteNumber()))
        }
    }

    const getDisplayText = () => {
        let displayText
        if(optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField?.length > 0 && addressQualificationDetails?.HasExistingService){
            displayText = "According to our records, this address already has Verizon services & Business Quote."
        } else if (optixAddressQualificationDetails?.quoteResultsField?.priceQuotesSetField?.length > 0) {
            displayText = "According to our records, this address already has Verizon Business Quote."
        } else if (addressQualificationDetails?.HasExistingService) {
            displayText = "According to our records, this address already has Verizon services."
        } else {
            displayText = "According to our records, this address already has Verizon services."
        }
        return displayText

    }

    return (
        <div className="existing-customer-container" ref={scrollRef}>
            <div className="info-block">
                {isExistingServicePage ? (
                    
                       <Body size="large" primitive="p">
                           {"Would you like to: "}
                       </Body>
                  
                ) : (
                    <React.Fragment>
                    <MarginSpacerM>
                    <Body size="medium" primitive="p" bold={true}>
                        {getDisplayText()}
                    </Body>
                </MarginSpacerM>
                <MarginSpacerM>
                    {hasPriceQuoteNumber()?<Body size="medium" primitive="p">
                        There are a few ways to get set up. Select one below.
                    </Body>:<Body size="small" primitive="p">
                        There are a few ways to get set up. Select one below.
                    </Body>}
                </MarginSpacerM>
                </React.Fragment>
                )}
            </div>
            <div className="options-for-customer"  key={getServiceOptions()?.length}>
                {/* <RadioButtonGroup
                    defaultValue={hasPriceQuoteNumber()?'existing quote':'Y'}
                    key={getServiceOptions()?.length}
                    onChange={(e) => { onServiceChange(e) }}
                    data={getServiceOptions()}
                /> */}
                { hasPriceQuoteNumber() &&  <RadioButton  
                 key={"Review/access existing"}
                 onChange={(e) => { onServiceChange(e) }}
                 name="loopqual"
                 id="loopqual"
                //  label="Review/access existing quote"
                 children={'Review/access existing quote'}
                value={'existing quote'} 
                selected={radioValue === 'existing quote'}
                /> }
                <br/>
                 {(hasPriceQuoteNumber() && viewPriceQuoteInput) && <React.Fragment>
                    <Input label = "Enter price quote number" width="292px" placeholder="Enter price quote number" value={priceQuoteNumber || ""} name="price-quote-number" error={enableErrorMessageForPriceQuoteNumber} errorText={errorMessageForPriceQuoteNumber} onChange={savePriceQuote} />
                    <br/>
                     </React.Fragment>}
              
                <RadioButton  
                 key={"Set up new service"}
                 onChange={(e) => { onServiceChange(e) }}
                 name="loopqual"
                 id="loopqual"
                //  label="Set up new service."
                 children={'Set up new service.'}
                value={'Y'} 
                selected={radioValue === 'Y'}
                />
                <br/>
             {  (addressQualificationDetails?.HasExistingService || previousHasExistingService !== 'N') &&  <RadioButton 
              
                 key={"Add or change existing service"}
                 onChange={(e) => { onServiceChange(e) }}
                 name="loopqual"
                 id="loopqual"
                //  label="Add or change existing service. The existing service is mine."
                 children={'Add or change existing service. The existing service is mine.'}
                value={'N'} 
                 selected={radioValue === 'N'}
                />}
                <br/>
            </div>
            <div className="continue-button">
                <Button size="large" onClick={(e) => { onContinue(e) }}>Continue</Button>
            </div>
            <MarginSpacerM />
        </div>
    );
}

export default ExistingCustomer;